import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function YoutubeVideoCardAlarmAreas() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="lZ9L8qd2v4k"
                    title="Alarm - Bereiche / Anleitung zur Weboberfläche einer INSTAR 2K+ / 4K Überwachungskamera"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="Alarmbereiche"
              footer={
                <EuiText>
                  <p>Alarm - Bereiche / Anleitung zur Weboberfläche einer INSTAR 2K+ / 4K Überwachungskamera</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
